import {
    HttpEvent,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
    HttpInterceptor
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, retry, switchMap, tap } from 'rxjs/operators';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { ErrorDetailsService } from 'bi-modules';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from '../shared/services/HttpClientServices/Http.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RefreshTokenService } from './Services/refresh-token.service';
@Injectable()
export class ErrorIntercept implements HttpInterceptor {
    constructor(private _router: Router,private jwtHelper: JwtHelperService,
       private environment: AppConfigService,private http:HttpService ,
        private errorDetailsService: ErrorDetailsService, private translateService: TranslateService,
      private refreshTokenService: RefreshTokenService) { }

    getRequest(next,request):Observable<HttpEvent<any>> {
      return next.handle(request)
      .pipe(tap(
        (res) => {
          if (this.environment.closeRow) {
            if (request.url.includes("batch")) {
              if (request.url.includes("batch") && res?.['body'] && request?.["body"]?.['requests']?.[0]?.['method'] === "POST") {
                this.environment.setHandleRes(res?.['body']?.['responses']?.[0]?.['status'] >= 200 && res?.['body']?.['responses']?.[0]?.['status'] < 300);
              }
            } else if (request['method'] == "POST" || request['method'] == "PUT") {
              this.environment.setHandleRes(res['status'] >= 200 && res['status'] < 300);
            }
          }
          }),
          catchError((error: HttpErrorResponse) => {
              if (error.status === 401) {
                localStorage.removeItem('ODataToken');
                this._router.navigate(['/login']);
              } else if(request?.['method'] === "POST") {
                  this.environment.setHandleRes(false)
              }

              if (error instanceof HttpErrorResponse) {     
                this.errorDetailsService.PushErrorMessages({
                  Title: this.translateService.instant(error.error?.error?.message?.value),
                  Details: this.translateService.instant(error.error?.innerError?.trace),
                  Link: error.url,
                  Id: 0,
                  Type: 0
                });
              }
              return throwError(error);
          }));
    }
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
      if (request.headers.get("skip"))
        return this.getRequest(next,request);
      const token = localStorage.getItem("ODataToken");
      if (token && this.jwtHelper.isTokenExpired(token)) {
        return this.refreshTokenService.tryRefreshingTokens().pipe(switchMap((response: any)=>{
          if(response){
            localStorage.setItem("ODataToken", response.Token);
            localStorage.setItem("jwt", response.Token);
            localStorage.setItem("refreshToken", response.RefreshToken);
            request = request.clone({
              setHeaders: {
                "Authorization": `Bearer ${response.Token}`
              }
            })
            return this.getRequest(next,request);
          }
        }),
        catchError((error) => {
          localStorage.removeItem('ODataToken');
          localStorage.setItem('redirectTo', window.location.href);
          this._router.navigate(["login"]);
          return throwError(error);
        }))
      }
      else
        return this.getRequest(next,request);
    }

}
